// @flow weak

import { bindActionCreators } from 'redux';
import { connect }            from 'react-redux';
import * as actions           from '../../redux/modules/actions';
import Collection                   from './Collection';

const mapStateToProps = (state) => {
  return {
    currentView:  state.views.currentView,
    statsTable:             state.statsTable,
    scoreCard:             state.scoreCard,
    statsGraph:             state.statsGraph,        
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions : bindActionCreators(
      {
        enterPage: actions.enterPage,
        leavePage: actions.leavePage,
        fetchStatsTableDataIfNeeded:  actions.fetchStatsTableDataIfNeeded,
        fetchScoreCardDataIfNeeded:  actions.fetchScoreCardDataIfNeeded,
        fetchStatsGraphDataIfNeeded:  actions.fetchStatsGraphDataIfNeeded,                
      },
      dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Collection);



// WEBPACK FOOTER //
// ./src/app/views/collection/index.js